<script setup>
import { WdsButtonLink, WdsIllustration, WdsLogo } from '@wds/components';
</script>

<template>
  <section class="climate-neutral-wrapper">
    <div class="climate-neutral-content">
      <div class="image-container">
        <img
          :alt="$t('t_CLIMATENEUTRALPHOTOALT')"
          :title="$t('t_CLIMATENEUTRALPHOTO')"
          height="488"
          loading="lazy"
          src="https://a.hwstatic.com/image/upload/f_auto,h_488,q_50/v1659430249/pwa/cnc/palmar.beach.lodge.jpg"
          width="672"
        />

        <div class="caption">
          <p class="body-2-bld">
            Palmar Beach Lodge, Panama
          </p>
          <p class="body-2-reg">
            Hoscars 2022 Winner
          </p>
        </div>
      </div>
      <div class="text-content">
        <WdsIllustration
          :alt="$t('t_CLIMATENEUTRALALTTITLEALT')"
          :title="$t('t_CLIMATENEUTRALALTTITLEALT')"
          asset="eco"
          class="illustration"
          folder="lg"
          loading="lazy"
        />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <h2
          class="text-header"
          v-html="$t('t_CLIMATENEUTRALTITLE')"
        />
        <p class="text-body body-1-reg">
          {{ $t('t_CLIMATENEUTRALBODY') }}
        </p>
        <WdsButtonLink
          :text="$t('t_LEARNMORESUSTAINABILITY')"
          :title="$t('t_CLIMATENEUTRALALTTITLE')"
          class="learn-more"
          href="https://global.hostelworld.com/sustainability"
          rel="noopener"
          type="button"
        />
        <WdsLogo
          :alt="$t('t_CLIMATENEUTRALCOMPANYALT')"
          :title="$t('t_CLIMATENEUTRALCOMPANY')"
          asset="cnc"
          class="cnc-logo"
          height="75"
          loading="lazy"
          width="150"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.climate-neutral-wrapper {
  position: relative;

  @include desktop {
    margin-left: auto;
    margin-right: auto;
  }

  .learn-more {
    text-decoration: none;
    cursor: pointer;
    margin: auto;

    @include desktop {
      margin-left: 0;
    }
  }

  .climate-neutral-content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    margin: $wds-spacing-xxl 0;
    margin-top: calc(#{$wds-spacing-xxxl} + #{$wds-spacing-xs});
    padding: 0 $wds-spacing-l;

    @include tablet-large {
      max-width: wds-rem(768px);
      margin-top: 0;
      margin-left: auto;
      margin-right: auto;
    }

    @include desktop {
      padding: 0 $wds-spacing-m;
      grid-template-columns: 1fr 1fr;
      gap: $wds-spacing-xxl;
      max-width: wds-rem(1368px);
    }

    @include desktop {
      margin-bottom: $wds-spacing-xxl;
    }

    & img {
      object-fit: contain;
      max-height: wds-rem(488px);
      display: block;
      margin: 0 auto;
      width: wds-rem(672px);

      @include desktop-large {
        margin: unset;
      }
    }

    .caption {
      padding-top: $wds-spacing-m;
    }

    .text-content {
      display: flex;
      flex-direction: column;
      text-align: center;

      @include desktop {
        text-align: unset;
        padding-bottom: $wds-spacing-m;
      }

      .illustration {
        width: wds-rem(104px);
        height: wds-rem(104px);

        @include desktop {
          margin-left: 0;
          width: wds-rem(96px);
          height: wds-rem(96px);
        }
      }

      .cnc-logo {
        width: wds-rem(150px);
        filter: brightness(0);
        margin-top: $wds-spacing-xl;

        @include desktop {
          margin-left: 0;
        }
      }
    }

    .text-header {
      font-family: $font-family-poppins;
      font-size: wds-rem(40px);
      line-height: wds-rem(40px);
      font-weight: 700;
      letter-spacing: $wds-letter-spacing-title-2;
      margin-top: $wds-spacing-m;

      &:deep(span) {
        color: $wds-color-green-dark;
      }

      @include tablet {
        font-size: 64px;
        line-height: 72px;
      }
    }

    .image-container {
      display: none;

      @include desktop {
        display: block;
      }
    }

    .text-body {
      margin-top: $wds-spacing-m;
    }
  }
}
</style>
